import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

function Faq() {
  const [copied, setCopied] = React.useState(false); 
     
  const [inputFieldsFaq, setInputFieldsFaq] = useState([{
      '@type': "Question",
      name: '',
      acceptedAnswer:  {
        '@type': "Answer",
        text: ""
      },
  }]) 
  const handleChange3 = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsFaq];
    if(name==='text')
    {
      list[index]['acceptedAnswer']['text'] = value;
    }
    else{
      list[index][name] = value;
    }
    setInputFieldsFaq(list);
  } 
  function MyButton(props) {
    return <button {...props} />
  } 
   
  const addInputFieldFaq = () => {
    setInputFieldsFaq([...inputFieldsFaq, {
      '@type': "Question",
      name: '',
      acceptedAnswer:  {
        '@type': "Answer",
        text: ""
      },
    }])

  }
  const removeInputFieldsFaq = (index) => {
    const rows = [...inputFieldsFaq];
    rows.splice(index, 1);
    setInputFieldsFaq(rows);
  }
   
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])  
  const FaqIsMyCopy = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/", 
      "@type": "FAQPage", 
      "mainEntity": [ `+
      inputFieldsFaq.map((items) =>
            `{
                "@type":"Question",
                "name":"`+items.name+`",
                "acceptedAnswer": {
                      "@type":"Answer",
                      "text":"`+items.acceptedAnswer.text+`"
                }
            }`

      )

      + ` ]
    }
    </script><!--FaqList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`; 
    const resetFun = () =>{
      console.log("inputFieldsFaq::::", inputFieldsFaq)
      const restdata = {
        '@type': "Question",
        name: '',
        acceptedAnswer:  {
          '@type': "Answer",
          text: ""
        },
    };
      setInputFieldsFaq([restdata]);
    }
  return (  
        <div className='row mt-5 faq_row'>
          <div className='col-md-8 mb-5 border'>
          <div className="mb-4 breadcrumb_row_title"><h2>Form for generate JSON-LD Schema Markup</h2></div>
          <p>Use the following JSON-LD schema generator to generate the markup code for the FAQ page:</p>
          <small>Press <i className="fa-solid fa-plus"></i> to add another Question/Answer</small>
          <div className='mt-2 d-flex faq_header'>
          <div className='col-5'>
          <b>Questions</b>
          </div>
          <div className='col-5'>
          <b>Answers</b>
          </div>
          <div className='col-2 justify-content-center'>
           
          </div>
        </div>
           {
             inputFieldsFaq.map((data, index) => {
              console.log("datda==", data)
               return (
                 <div className="input_fields d-flex" key={index}>
                   <div className="col-5 d-block">
                     <div className="form-group me-2 mb-2">
                       <input type="text" onChange={(evnt) => handleChange3(index, evnt)} value={data.name} name="name" className="form-control" placeholder="Question" />
                     </div>
                   </div>
                   <div className="col-5 d-block">
                     <div className="form-group me-2 mb-2">
                       <input type="text" onChange={(evnt) => handleChange3(index, evnt)} value={data.acceptedAnswer.text} name="text" className="form-control" placeholder="Answer" />                        
                     </div>
                   </div>
                   <div className="col-2 justify-content-center">
                     {(inputFieldsFaq.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={()=>removeInputFieldsFaq(index)}><i className="fa-solid fa-minus"></i></button> : ''}
                   </div>
                 </div>
               )
             })
           }
           <div className="col mt-3 mb-3">
            <b><button className="btn btn-outline-success addbtn" onClick={addInputFieldFaq}><i className="fa-solid fa-plus"></i></button></b>
           </div>
          </div>
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={FaqIsMyCopy} >
                 <MyButton className="btn btn-success"> <i className="fa-solid fa-copy me-2"></i> Copy</MyButton>
               </CopyToClipboard>
                
                 <MyButton className="btn btn-success" onClick={()=>resetFun()}> <i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
             </div>
             <div className="card-body">
               {FaqIsMyCopy}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}      
export default Faq